// @ vendors
const { Promise } = require('es6-promise');

// @ commons
const { APIGet } = require('utilities/APIRequestHelper');
const apiURLBuilder = require('core/apiURLBuilder');

// @ actions
const { requestMortgageData } = require('actions/mortgageRequest/mortgageRequestMortgageData');

// @ constants
const {
    INSURANCE_REQUEST_RELATED_RNC_STATE_REQUEST,
    INSURANCE_REQUEST_RELATED_RNC_STATE_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_STATE_FAILURE,
    INSURANCE_REQUEST_RELATED_RNC_RECOMMENDATION_REQUEST,
    INSURANCE_REQUEST_RELATED_RNC_RECOMMENDATION_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_RECOMMENDATION_FAILURE,
    INSURANCE_REQUEST_RELATED_RNC_STATE_APPRAISAL,
    INSURANCE_REQUEST_RELATED_RNC_POST_CLOSED_PRICE,
    INSURANCE_REQUEST_RELATED_RNC_PRICING_REQUEST,
    INSURANCE_REQUEST_RELATED_RNC_PRICING_SUCCESS,
    INSURANCE_REQUEST_RELATED_RNC_PRICING_FAILURE,
} = require('../../insuranceConstants/actionTypes');
const { WIZARD_REQUEST_RESPONSE_OPTIONS } = require('../../insuranceConstants/insuranceRequestHome');

const requestInsuranceStateInProgress = () => ({
    type: INSURANCE_REQUEST_RELATED_RNC_STATE_REQUEST
});

const requestInsuranceStateSuccess = (insuranceState, idExpediente) => ({
    type: INSURANCE_REQUEST_RELATED_RNC_STATE_SUCCESS,
    data: {
        insuranceState,
        idExpediente,
    }
});

const requestInsuranceStateFailure = error => ({
    type: INSURANCE_REQUEST_RELATED_RNC_STATE_FAILURE,
    data: { error }
});

const requestInsuranceRelatedRNCRecommendationInProgress = () => ({
    type: INSURANCE_REQUEST_RELATED_RNC_RECOMMENDATION_REQUEST
});

const requestInsuranceRelatedRNCRecommendationSuccess = data => ({
    type: INSURANCE_REQUEST_RELATED_RNC_RECOMMENDATION_SUCCESS,
    data
});

const requestInsuranceRelatedRNCRecommendationFailure = error => ({
    type: INSURANCE_REQUEST_RELATED_RNC_RECOMMENDATION_FAILURE,
    data: { error }
});

const requestInsuranceRelatedRNCPricingInProgress = () => ({
    type: INSURANCE_REQUEST_RELATED_RNC_PRICING_REQUEST
});

const requestInsuranceRelatedRNCPricingSuccess = data => ({
    type: INSURANCE_REQUEST_RELATED_RNC_PRICING_SUCCESS,
    data
});

const requestInsuranceRelatedRNCPricingFailure = error => ({
    type: INSURANCE_REQUEST_RELATED_RNC_PRICING_FAILURE,
    data: { error }
});

const saveRelatedStateAppraisal = data => ({
    type: INSURANCE_REQUEST_RELATED_RNC_STATE_APPRAISAL,
    data
});

const getClosedPrice = response => ({
    type: INSURANCE_REQUEST_RELATED_RNC_POST_CLOSED_PRICE,
    data: { response }
})

const requestInsuranceRelatedRNCCurrentPricing = insuranceId => (dispatch, getState) => {
    const currentState = getState().insuranceRequestState;

    if (!currentState.get('isFetchingPricing')) {
        dispatch(requestInsuranceRelatedRNCPricingInProgress());

        return APIGet(
            dispatch,
            apiURLBuilder.getURL('insuranceRequestPricingDiscount', { id: insuranceId })
        )
            .then(response => {
                dispatch(requestInsuranceRelatedRNCPricingSuccess(response.data));
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(requestInsuranceRelatedRNCPricingFailure(response.error));
                } else {
                    throw response;
                }
            });
    } else {
        return Promise.resolve();
    }
};

const requestInsuranceRelatedRNCExpedient = insuranceId => (dispatch) => {
    dispatch(getClosedPrice(WIZARD_REQUEST_RESPONSE_OPTIONS.IS_FETCHING));
    return APIGet(
        dispatch,
        apiURLBuilder.getURL('insuranceRequestRelatedExpedient', { id: insuranceId })
    )
        .then(response => {
            const { closedPrice } = response.data;
            const closedPriceResponse = closedPrice ? WIZARD_REQUEST_RESPONSE_OPTIONS.SUCCESS : WIZARD_REQUEST_RESPONSE_OPTIONS.FALSE
            dispatch(getClosedPrice(closedPriceResponse))
        })
        .catch(response => {
            if (!!response.error) {
                dispatch(getClosedPrice(WIZARD_REQUEST_RESPONSE_OPTIONS.ERROR));
            } else {
                throw response;
            }
        });
}

const requestInsuranceRelatedRNCCurrentState = (insuranceIdDraft, mortgageId) => (dispatch, getState) => {
    const currentState = getState().insuranceRequestRelatedRNCState;
    const currentMortgageDataState = getState().mortgageRequestMortgageData;

    if (!currentState.get('isFetching')) {
        dispatch(requestInsuranceStateInProgress());

        if (!currentMortgageDataState.get('req')) {
            requestMortgageData()(dispatch, getState);
        }

        let getMortgageRequestStateRequest = null;
        let getInsuranceRequestRelatedState = null;

        const getInsuranceRequestRelatedAppraisalState = APIGet({
            dispatch,
            endpoint: 'insuranceRequestRelatedStateAppraisal'
        });

        if (insuranceIdDraft) {
            getInsuranceRequestRelatedState = APIGet(
                dispatch,
                apiURLBuilder.getURL('insuranceRequestStateRequest', { id: insuranceIdDraft })
            );
        } else {
            getInsuranceRequestRelatedState = APIGet({
                dispatch,
                endpoint: 'insuranceRequestRelatedCurrentState'
            });
        }

        let promises = [
            getInsuranceRequestRelatedState,
            getInsuranceRequestRelatedAppraisalState,
        ];

        // if we don't receive the mortgageId, call the mortgageRequestStateRequest
        // and add the promise to the promises array to resolve the response
        if (!mortgageId) {
            getMortgageRequestStateRequest = APIGet({
                dispatch,
                endpoint: 'mortgageRequestStateRequest',
            });

            promises.unshift(getMortgageRequestStateRequest);
        }

        return Promise.all(promises)
            .then(response => {
                // if we receive the mortgageId, modify the response
                // to add an empty element at the begining
                // This is to avoid index response differences
                if (!!mortgageId) {
                    response.unshift({});
                }

                const idExpediente = mortgageId || response[0].data.idExpediente;
                const insuranceRelatedStateResponse = insuranceIdDraft ? [response[1].data] : response[1].data;
                const insuranceRelatedState = insuranceRelatedStateResponse.length ? insuranceRelatedStateResponse[0] : null;
                const appraisalState = response[2];

                if (appraisalState && appraisalState.data) {
                    dispatch(saveRelatedStateAppraisal(appraisalState.data))

                    if (insuranceRelatedState && appraisalState.data.afterAppraisal) {
                        requestInsuranceRelatedRNCExpedient(insuranceRelatedState.id)(dispatch);
                        requestInsuranceRelatedRNCCurrentPricing(insuranceRelatedState.id)(dispatch, getState);
                    }
                }

                dispatch(requestInsuranceStateSuccess(insuranceRelatedState, idExpediente));
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(requestInsuranceStateFailure(response.error));
                } else {
                    throw response;
                }
            });
    } else {
        return Promise.resolve();
    }
};

const requestInsuranceRelatedRNCRecommendation = data => (dispatch, getState) => {
    const currentState = getState().insuranceRequestRelatedRNCState;

    if (!currentState.get('isFetchingRecommendation')) {
        dispatch(requestInsuranceRelatedRNCRecommendationInProgress());

        const params = {
            query: {
                size: data.size,
                propertyType: data.propertyType,
                propertyCharacter: data.propertyCharacter,
                propertyUsage: data.propertyUsage,
                content: data.content,
                provinceId: data.provinceId,
                continent: data.continent || null
            }
        };

        return APIGet({
            dispatch,
            endpoint: 'insuranceRecommentation',
            params
        })
            .then(response => {
                dispatch(requestInsuranceRelatedRNCRecommendationSuccess(response.recommendation));
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(requestInsuranceRelatedRNCRecommendationFailure(response.error));
                } else {
                    throw response;
                }
            });
    } else {
        return Promise.resolve();
    }
};

module.exports = {
    requestInsuranceRelatedRNCCurrentState,
    requestInsuranceRelatedRNCRecommendation,
    requestInsuranceRelatedRNCCurrentPricing
};
